const MEASUREMENT_ID = process.env.VUE_APP_GA_ID;
const DEBUG = process.env.NODE_ENV !== 'production';

export const config = {
  property: {
    id: MEASUREMENT_ID
  },
  isEnabled: true,
  bootstrap: true,
  params: {
    send_page_view: false,
    debug_mode: DEBUG
  }
};

export const pageView = (pageName, path) => {
  if (!MEASUREMENT_ID) return;
  window.gtag('event', 'page_view', {
    page_title: pageName,
    page_path: path,
    page_location: window.location.href
  });
};

export const trackPurchase = async (purchase) => {
  if (!purchase?.items?.length || !MEASUREMENT_ID) return;

  try {
    window.gtag('event', 'purchase', {
      currency: 'BRL',
      transaction_id: purchase.orderId || `T${Date.now()}`,
      value: purchase.total || 0,
      items: purchase.items.map(item => ({
        item_id: item.id || '',
        item_name: item.name || '',
        price: item.price || 0,
        quantity: item.quantity || 1
      }))
    });
  } catch (error) {
    console.error('Error tracking purchase:', error);
  }
};
